import {
  Button,
  Classes,
  H5,
  InputGroup,
  Popover
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { IIcmsAliquota } from "../../model";
import { IcmsAliquotaStore } from "../../stores/legislacao/IcmsAliquotaStore";
import { AppStore } from "../../stores/AppStore";
import { Pager } from "../utils/Pager";
import {
  MDBBtn, MDBCol, MDBRow,
} from "mdbreact";
import * as moment from "moment";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { IcmsAliquotasDialogEdit } from "./IcmsAliquotasDialogEdit";
import { IcmsAliquotasDialogDuplicar } from "./IcmsAliquotasDialogDuplicar";
import { IcmsAliquotasDialogCreate } from "./IcmsAliquotasDialogCreate";

var debounce = require('lodash.debounce');

interface Props { }

interface State { }

@observer
export class IcmsAliquotasPage extends React.Component<Props, State> {

  obs = observable({
    adding: false as boolean,
    aliquota_edit: null as IIcmsAliquota,
    aliquota_duplicar: null as IIcmsAliquota,
    fetchOptions: {} as any
  })

  constructor(props: Props) {
    super(props);

    this.obs.fetchOptions = debounce(this.handleFilter.bind(this), 800);

  }

  async componentDidMount() {
    AppStore.setTitle("ICMS Alíquotas");

    await IcmsAliquotaStore.Load();

  }

  handleAdd = () => {
    this.obs.adding = true;
  };

  handlePageChange = (page: number) => {
    IcmsAliquotaStore.obs.currentPage = page;
    IcmsAliquotaStore.handleFilter(page, IcmsAliquotaStore.obs.filter_origem, IcmsAliquotaStore.obs.filter_destino);
  };

  handleModalEdit = (aliquota: any) => {
    this.obs.aliquota_edit = aliquota

    if (this.obs.aliquota_edit.valido_de != null) {
      let newDate = new Date(this.obs.aliquota_edit.valido_de)
      newDate.setHours(newDate.getHours() + 24)
      this.obs.aliquota_edit.valido_de = newDate
    }

    if (this.obs.aliquota_edit.valido_ate != null) {
      let newDateAte = new Date(this.obs.aliquota_edit.valido_ate)
      newDateAte.setHours(newDateAte.getHours() - 3)
      this.obs.aliquota_edit.valido_ate = newDateAte
    }
  }

  handleModalDuplicar = (aliquota: any) => {
    this.obs.aliquota_duplicar = aliquota

    if (this.obs.aliquota_duplicar.valido_de != null) {
      let newDate = new Date(this.obs.aliquota_duplicar.valido_de)
      newDate.setHours(newDate.getHours() + 24)
      this.obs.aliquota_duplicar.valido_de = newDate
    }

    if (this.obs.aliquota_duplicar.valido_ate != null) {
      let newDateAte = new Date(this.obs.aliquota_duplicar.valido_ate)
      newDateAte.setHours(newDateAte.getHours() - 3)
      this.obs.aliquota_duplicar.valido_ate = newDateAte
    }
  }

  handleEditClose = () => {
    this.obs.aliquota_edit = null;
  };

  handleDuplicaClose = () => {
    this.obs.aliquota_duplicar = null;
  };

  validadeFormatter(d) {
    return d ? moment(d).add(3, "hour").format("DD/MM/YYYY") : null;
  }
  aliquotaFormatter(d) {
    return d ? d.toString().concat("%") : null
  }

  async handleFilter() {

    IcmsAliquotaStore.obs.currentPage = 1

    await IcmsAliquotaStore.handleFilter(1, IcmsAliquotaStore.obs.filter_origem, IcmsAliquotaStore.obs.filter_destino)

  }

  async handleFilterOrigem(filtro_origem) {

    IcmsAliquotaStore.obs.filter_origem = filtro_origem

    this.obs.fetchOptions()

  }

  async handleFilterDestino(filter_destino) {

    IcmsAliquotaStore.obs.filter_destino = filter_destino

    this.obs.fetchOptions()

  }

  render() {
    let items = IcmsAliquotaStore.obs.icms_aliquotas_paginate?.map((icms) => {
      return (
        {
          id: icms._id,
          origem_uf: icms.origem_uf,
          destino_uf: icms.destino_uf,
          aliquota_pct: icms.aliquota_pct,
          valido_de: icms.valido_de,
          valido_ate: icms.valido_ate,
        }
      );
    });

    const buttonFormatterDetalhes = (cell, row) => {
      return (
        <>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            onClick={() => this.handleModalEdit(row)}
          >
            <img src="/images/edit.png" width={20} />
          </MDBBtn>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            onClick={(e) => this.handleModalDuplicar(row)}
          >
            <img src="/images/duplicate.svg" width={20} />
          </MDBBtn>
          <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
            <MDBBtn color="default" rounded size="sm">
              <img src="/images/bin.png" width={20} />
            </MDBBtn>
            <div>
              <H5>Confirmar exclusão?</H5>
              <p>Confirmar exclusão do ICMS Alíquota?</p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: 15,
                }}
              >
                <Button
                  className={Classes.POPOVER_DISMISS}
                  style={{ marginRight: 10 }}
                >
                  Cancelar
                </Button>
                <Button
                  intent="danger"
                  className={Classes.POPOVER_DISMISS}
                  onClick={() => IcmsAliquotaStore.handleDeleteIcms(row.id)}
                >
                  Excluir
                </Button>
              </div>
            </div>
          </Popover>
        </>
      )
    }

    let user_admin = AppStore.obs1.usuario ? AppStore.obs1.usuario.admin : false

    return (
      <>
        <div>

          {user_admin &&
            <MDBRow>
              <MDBCol md="3">
                <MDBBtn className="btnDefault noFloat" onClick={this.handleAdd} style={{ marginBottom: "20px" }}>
                  Adicionar ICMS Alíquota
                </MDBBtn>
              </MDBCol>
            </MDBRow>
          }

          <MDBRow>
            <MDBCol md="4">
              <InputGroup
                round
                style={{ width: "48%", float: "left", borderRadius: "10px" }}

                placeholder="Filtrar (Origem UF)"
                value={IcmsAliquotaStore.obs.filter_origem}
                onChange={(e: any) => this.handleFilterOrigem(e.target.value)}
              />
              <InputGroup
                round
                style={{ width: "48%", float: "right", borderRadius: "10px" }}
                placeholder="Filtrar (Destino UF)"
                value={IcmsAliquotaStore.obs.filter_destino}
                onChange={(e: any) => this.handleFilterDestino(e.target.value)}
              />
            </MDBCol>
          </MDBRow>

          <div className="TableDefault mvasTable">
            <BootstrapTable className="TableDefault" ref="table" data={items}>
              <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
              <TableHeaderColumn dataField="origem_uf" width="20%">Origem UF</TableHeaderColumn>
              <TableHeaderColumn dataField="destino_uf" width="20%">Destino UF</TableHeaderColumn>
              <TableHeaderColumn dataField="aliquota_pct" dataFormat={this.aliquotaFormatter} width="20%">Alíquota</TableHeaderColumn>
              <TableHeaderColumn dataField="valido_de" dataFormat={this.validadeFormatter} width="15%">Valido de</TableHeaderColumn>
              <TableHeaderColumn dataField="valido_ate" dataFormat={this.validadeFormatter} width="15%"> Valido até </TableHeaderColumn>
              {user_admin && <TableHeaderColumn dataFormat={buttonFormatterDetalhes} width="20%">Ações</TableHeaderColumn>}
            </BootstrapTable>
          </div>

          <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
            <Pager
              currentPage={IcmsAliquotaStore.obs.currentPage}
              totalCount={IcmsAliquotaStore.obs.totalRows}
              pageSize={27}
              onPageChange={this.handlePageChange} />
          </div>
        </div>

        {this.obs.adding && <IcmsAliquotasDialogCreate onClose={() => this.obs.adding = false} />}
        {this.obs.aliquota_edit &&
          <IcmsAliquotasDialogEdit aliquota={this.obs.aliquota_edit} onClose={this.handleEditClose} />
        }
        {this.obs.aliquota_duplicar &&
          <IcmsAliquotasDialogDuplicar aliquota={this.obs.aliquota_duplicar} onClose={this.handleDuplicaClose} />
        }
      </>
    );
  }
}

export default IcmsAliquotasPage;